import(/* webpackMode: "eager", webpackExports: ["ZinniaFonts","ZinniaProvider"] */ "/vercel/path0/node_modules/.pnpm/@zapier+design-system@8.9.2_@types+react@18.3.20_react-dom@18.3.1_react@18.3.1/node_modules/@zapier/design-system/dist/index.es.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.0_@babel+core@7.26.10_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["DatadogInit"] */ "/vercel/path0/packages/observability/src/DatadogInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CanvasProvider"] */ "/vercel/path0/packages/service/src/app/CanvasProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/service/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/canvas/src/components/Canvas/styles/GlobalCanvasStyles.css");
